export default __webpack_public_path__ + "static/media/stackable_ring.ebb22500.webp";